// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../.0.28.7@css-loader/index.js??ref--1-oneOf-3-2!../../../../.2.0.8@postcss-loader/lib/index.js??postcss!../../../../.4.1.0@less-loader/dist/cjs.js??ref--1-oneOf-3-4!./index.less");
if(typeof content === 'string') content = [[module.id, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":false}
options.transform = transform
// add the styles to the DOM
var update = require("!../../../../.0.19.0@style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;



//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/lib/switch/style/index.less
// module id = 1194
// module chunks = 0